import { createAction, props } from '@ngrx/store';
import { ResponseTri, RequestTri } from '../../shared/interfaces';
import { TriTypes } from '../../shared/enums';


export const getTri = createAction(
    TriTypes.TRI,
    props<{ request: RequestTri}>()
);

export const getTriSucess = createAction(
    TriTypes.TRI_SUCCESS,
    props<{ response: ResponseTri }>()
);

export const getTriError = createAction(
    TriTypes.TRI_ERROR,
    props<{ payload: any }>()
);

export const cleanState = createAction(
    TriTypes.CLEAN_STATE
);
